// extracted by mini-css-extract-plugin
export default {"header":"header_header__Njane","wrapper":"header_wrapper__+sRPP","logo":"header_logo__OsDUg"};